import axios from "axios"
import { API } from "./api"
import { IndustryResponse } from "../types/index"

export const getSeoData = () => axios.get(API.url + "/seo?populate=*").then((res) => res.data.data.attributes)

export const getIndustries = () => axios.get(API.url + "/branches?populate=*").then((res) => res.data.data as IndustryResponse[])